import React from "react";
import {
  faClock,
  faTooth,
  faWater,
  faWhiskeyGlass,
} from "@fortawesome/free-solid-svg-icons";
import "../style/About.css";
import "../style/Common.css";
import aboutUs from "../images/More.jpg";
import aboutUsMobile from "../images/doctor-checking.jpg";
import "../style/More.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import YoutubeShorts from "./YoutubeShorts";
import { useMediaQuery } from "react-responsive";

const instructions = [
  {
    icon: <FontAwesomeIcon icon={faTooth} size="2xl" />,
    title: "Brush Regularly",
    description:
      "Clean your aligners gently with a soft toothbrush to avoid buildup.",
  },
  {
    icon: <FontAwesomeIcon icon={faWhiskeyGlass} size="2xl" />,
    title: "Avoid Hot Drinks",
    description:
      "Remove aligners before drinking hot beverages to prevent damage or distortion.",
  },
  {
    icon: <FontAwesomeIcon icon={faClock} size="2xl" />,
    title: "Wear Consistently",
    description: "Wear aligners 20-22 hours a day for optimal results.",
  },
  {
    icon: <FontAwesomeIcon icon={faWater} size="2xl" />,
    title: "Keep Hydrated",
    description: "Always rinse aligners with cool water after removal.",
  },
];

const Results = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  return (
    <section className="more" id="more">
      <div className="about-us-container">
        <div className="about-us-content">
          <h1>Results</h1>
          <nav className="breadcrumb">
            <span>Home</span>
            <span className="separator">|</span>
            <span>Results</span>
          </nav>
        </div>
        <div className="about-us-image">
          {isMobile ? (
            <img src={aboutUsMobile} alt="About Us" className="mobile-image" />
          ) : (
            <img src={aboutUs} width={"24px"} alt="About Us" />
          )}
        </div>
      </div>
      <br />
      <br />
      <br />
      <div
        id="results-section"
        style={{
          position: "relative",
          top: "-120px",
          height: "0px",
          overflow: "hidden",
        }}
      />
      <YoutubeShorts />

      <div
        id="care-section"
        style={{
          position: "relative",
          top: "-120px",
          height: "0px",
          overflow: "hidden",
        }}
      />
      <section className="aligner-care">
        <h2 className="care-section-title">
          Instructions for Taking Care of Your Aligners
        </h2>
        <div className="care-instructions">
          {instructions.map((item, index) => (
            <div className="instruction-item" key={index}>
              <div className="instruction-icon">{item.icon}</div>
              <h3 className="instruction-title">{item.title}</h3>
              <p className="instruction-description">{item.description}</p>
            </div>
          ))}
        </div>
      </section>
      <div
        id="tips-section"
        style={{
          position: "relative",
          top: "-120px",
          height: "0px",
          overflow: "hidden",
        }}
      />
      <div className="instructions-section">
        <h2 className="instructions-subtitle">Your Smile Tips Guide</h2>
        <br />
        <h3 className="instructions-title">
          General Essential Tips For Your Invisible Aligners
        </h3>
        <div className="instructions-container">
          <section class="instruction-section">
            <h2>1. Getting Started</h2>
            <ul>
              <li>Start wearing your first set of aligners as instructed.</li>
              <li>Insert and remove them with clean hands.</li>
              <li>
                Mild pressure or tightness is normal in the first few days.
              </li>
            </ul>
          </section>
          {/* <section class="instruction-section">
            <h2>2. Daily Wear &amp; Care</h2>
            <ul>
              <li>Wear aligners for 22 hours a day.</li>
              <li>
                Remove only for eating, drinking (except water), and oral
                hygiene.
              </li>
              <li>Clean daily with a soft toothbrush and lukewarm water.</li>
              <li>Store in your case when not in use.</li>
            </ul>
          </section> */}
          {/* <section class="instruction-section">
            <h2>3. Switching Aligners</h2>
            <ul>
              <li>Switch to a new set every 2 weeks, or as directed.</li>
              <li>
                Always follow the correct sequence provided with your treatment
                plan.
              </li>
            </ul>
          </section> */}
          <section class="instruction-section">
            <h2>2. Oral Hygiene</h2>
            <ul>
              <li>
                Brush and floss after every meal before reinserting aligners.
              </li>
              <li>
                Keeping your teeth and aligners clean helps avoid staining,
                odor, and buildup.
              </li>
            </ul>
          </section>
          <section class="instruction-section">
            <h2>3. Managing Discomfort</h2>
            <ul>
              <li>
                Pressure or tightness is expected—it means the aligners are
                working.
              </li>
              <li>For sharp pain or irritation, contact your clinic.</li>
            </ul>
          </section>
          <section class="instruction-section">
            <h2>4. After Treatment</h2>
            <ul>
              <li>Retainers may be needed to keep your new smile in place.</li>
              <li>Your doctor will guide you through this step.</li>
            </ul>
          </section>
        </div>
      </div>
      {/* <Testimonials /> */}
    </section>
  );
};

export default Results;
